import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import Login from './components/Login';
import DriverLogin from './components/DriverLogin';
import PassengerLogin from './components/PassengerLogin';
import DriverRegistration from './components/DriverRegistration';
import PassengerRegistration from './components/PassengerRegistration';
import DriverDashboard from './components/DriverDashboard';
import PassengerDashboard from './components/PassengerDashboard';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import AccountDeleteForm from './components/AccountDeleteForm';
import SupportPage from './components/SupportPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/driver-login" element={<DriverLogin />} />
          <Route path="/passenger-login" element={<PassengerLogin />} />
          <Route path="/driver-registration" element={<DriverRegistration />} />
          <Route path="/passenger-registration" element={<PassengerRegistration />} />
          <Route path="/driver-dashboard" element={<DriverDashboard />} />
          <Route path="/passenger-dashboard" element={<PassengerDashboard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/hesap-silme-talebi" element={<AccountDeleteForm />} />
          <Route path="/destek" element={<SupportPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
